export const SCHEME_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  MATURED: "MATURED",
  CANCELLED: "CANCELLED",
}

export const INSTALMENT_STATUS = {
  UPCOMING: "UPCOMING",
  DUE: "DUE",
  PAID: "PAID",
  MISSED: "MISSED",
  CANCELLED: "CANCELLED",
}

export const INSTALMENT_TYPE = {
  CUSTOMER: "CUSTOMER",
  BONUS: "BONUS",
}

export const SCHEME_TABS = [
  { value: SCHEME_STATUS.ACTIVE, label: "Active" },
  { value: SCHEME_STATUS.PENDING, label: "Pending" },
  { value: SCHEME_STATUS.MATURED, label: "Matured" },
  { value: SCHEME_STATUS.CANCELLED, label: "Cancelled" },
]

export const SCHEME_STATUS_CHIP = {
  [SCHEME_STATUS.ACTIVE]: {
    label: "Active",
    bg: "success.light",
    color: "success.dark",
  },
  [SCHEME_STATUS.PENDING]: {
    label: "Pending",
    bg: "grey.100",
    color: "text.secondary",
  },
  [SCHEME_STATUS.MATURED]: {
    label: "Matured",
    bg: "info.light",
    color: "info.dark",
  },
  [SCHEME_STATUS.CANCELLED]: {
    label: "Cancelled",
    bg: "grey.100",
    color: "grey.600",
  },
}

export const INSTALMENT_VIEW = {
  PAID: "PAID",
  DUE_NOW: "DUE_NOW",
  IN_GRACE: "IN_GRACE",
  OVERDUE: "OVERDUE",
  SCHEDULED: "SCHEDULED",
  UPCOMING: "UPCOMING",
  MISSED: "MISSED",
  CANCELLED: "CANCELLED",
  BONUS_PENDING: "BONUS_PENDING",
  BONUS_CREDITED: "BONUS_CREDITED",
}

export const INSTALMENT_VIEW_CHIP = {
  [INSTALMENT_VIEW.PAID]: { label: "Paid", color: "success.main" },
  [INSTALMENT_VIEW.DUE_NOW]: { label: "Due now", color: "warning.dark" },
  [INSTALMENT_VIEW.IN_GRACE]: { label: "In grace", color: "warning.dark" },
  [INSTALMENT_VIEW.OVERDUE]: { label: "Overdue", color: "error.main" },
  [INSTALMENT_VIEW.SCHEDULED]: { label: "Scheduled", color: "grey.600" },
  [INSTALMENT_VIEW.UPCOMING]: { label: "Upcoming", color: "grey.500" },
  [INSTALMENT_VIEW.MISSED]: { label: "Missed", color: "error.main" },
  [INSTALMENT_VIEW.CANCELLED]: { label: "Cancelled", color: "grey.500" },
  [INSTALMENT_VIEW.BONUS_PENDING]: {
    label: "On completion",
    color: "grey.600",
  },
  [INSTALMENT_VIEW.BONUS_CREDITED]: {
    label: "Credited",
    color: "success.main",
  },
}

export const AMOUNT_PRESETS = [500, 1000, 2000, 5000, 10000]

export const FALLBACK_CUSTOMER_INSTALMENTS = 11

export const CLOSED_SCHEME_STATUSES = [
  SCHEME_STATUS.MATURED,
  SCHEME_STATUS.CANCELLED,
]

export const PAYMENT_STATUS = {
  CHECKOUT: "CHECKOUT",
  PROCESSING: "PROCESSING",
  PAID: "PAID",
  REFUNDED: "REFUNDED",
  REFUND_FAILED: "REFUND_FAILED",
}

export const PAYMENT_POLL_ATTEMPTS = 3

export const PAYMENT_POLL_INTERVAL_MS = 5000

export const PAYMENT_NOTICE_DURATION_MS = 8000

export const REFUND_NOTICE_DURATION_MS = 15000

export const PAYMENT_VERIFY_TIMEOUT_MS = 30000

export const PAYMENT_TOAST_ID = "scheme-payment"
